export default "__VITE_ASSET__jMMFx1t5__"